// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2rAeF","footer":"ReportModalFilter_footer__1jJg8"};